// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// const PrivateRoute = ({ children }) => {
//   const { corporator, loading } = useAuth();

//   if (loading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         fontSize: '1.2rem',
//         color: '#666'
//       }}>
//         Loading...
//       </div>
//     );
//   }

//   return corporator ? children : <Navigate to="/login" />;
// };

// export default PrivateRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const auth = useAuth();

  // 🔐 Safety check: context not ready
  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  const { corporator, loading } = auth;

  // ⏳ Loading state
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '1.1rem',
          color: '#666'
        }}
      >
        Loading...
      </div>
    );
  }

  // 🚫 Not authenticated
  if (!corporator) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Authenticated
  return <>{children}</>;
};

export default PrivateRoute;
